/**
 * @generated SignedSource<<0927e9070061c195fed38a6366179da3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApprovalStyle = "AUTOMATIC" | "MANUAL" | "%future added value";
export type UpdateCapabilityInput = {
  approvalStyle?: ApprovalStyle | null | undefined;
  description?: string | null | undefined;
  id: any;
  integrationId?: any | null | undefined;
  isActive?: boolean | null | undefined;
  name?: string | null | undefined;
  parametersSchema?: any | null | undefined;
  targetConfig?: any | null | undefined;
};
export type CapabilitiesWorkspaceUpdateMutation$variables = {
  input: UpdateCapabilityInput;
};
export type CapabilitiesWorkspaceUpdateMutation$data = {
  readonly updateCapability: {
    readonly capability: {
      readonly id: any;
      readonly isActive: boolean;
      readonly name: string;
    } | null | undefined;
    readonly error: string | null | undefined;
  };
};
export type CapabilitiesWorkspaceUpdateMutation = {
  response: CapabilitiesWorkspaceUpdateMutation$data;
  variables: CapabilitiesWorkspaceUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCapabilityPayload",
    "kind": "LinkedField",
    "name": "updateCapability",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCapability",
        "kind": "LinkedField",
        "name": "capability",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CapabilitiesWorkspaceUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CapabilitiesWorkspaceUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40b0d97d8058a21ab75c840ee46703f7",
    "id": null,
    "metadata": {},
    "name": "CapabilitiesWorkspaceUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CapabilitiesWorkspaceUpdateMutation(\n  $input: UpdateCapabilityInput!\n) {\n  updateCapability(input: $input) {\n    capability {\n      id\n      name\n      isActive\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "d5fbfe00f0fe22e9dc03bdaeea52983c";

export default node;
